export function deriveJudgeBonusTotals(judges = [], submissions = {}) {
  return judges.reduce((totals, judgeName) => {
    const key = judgeName.replace(/[\.\#\$\/\[\]]/g, "_");
    const submission = submissions[key];
    if (!submission?.complete) return totals;
    if (submission.boutWinner === "red") totals.red += 1;
    if (submission.boutWinner === "blue") totals.blue += 1;
    return totals;
  }, { red: 0, blue: 0 });
}

export function deriveBonusAdjustedTotals({ scoreRed, scoreBlue, judges = [], submissions = {} }) {
  const bonuses = deriveJudgeBonusTotals(judges, submissions);
  return { red: scoreRed + bonuses.red, blue: scoreBlue + bonuses.blue };
}

export function deriveConfirmedBoutResult({ scoreRed, scoreBlue, fighterRed, fighterBlue, phase }) {
  if (String(scoreRed ?? "").trim() === "" || String(scoreBlue ?? "").trim() === "") {
    throw new Error("Scores must be non-negative whole numbers.");
  }
  const scoreA = Number(scoreRed);
  const scoreB = Number(scoreBlue);
  if (!Number.isInteger(scoreA) || !Number.isInteger(scoreB) || scoreA < 0 || scoreB < 0) {
    throw new Error("Scores must be non-negative whole numbers.");
  }
  if (phase !== "pool" && scoreA === scoreB) {
    throw new Error("Elimination bouts cannot be confirmed as a draw. Add a tiebreaker round.");
  }

  return {
    scoreA,
    scoreB,
    winner: scoreA > scoreB ? fighterRed : scoreB > scoreA ? fighterBlue : "Draw",
  };
}
